import React, { useEffect } from "react"
import {every, isEmpty, map, some} from "lodash"
import _ from "lodash"
import { WithChampionshipBet, useRound, useOverview, useChampionshipBet } from "./context"
import {ChampionshipBetPick, ChampionshipBetTeam, PickValue, TChampionshipBet, TeamId} from "./types"
import usePicker, { WithPicker } from "./usePicker"
import { ChangeTeam, PairingRow, PickedProgress, RankingRow, SectionHeader, SelectTeam, SelectWinner , SelectionRow } from "./ui"
import I18n from "i18n-js"
import {buildPicks, pickIsSet} from "./helper"
import useTutorialPopup, { WithTutorialPopup } from "./useTutorialPopup"

const Overview = () => {

  const { pickedPercent } = useOverview()

  return <div className="championshipBet__overview">
    <a href="#finals" className="championshipBet__overview__rowLabel">
      {I18n.t("championshipbet.finals.section_header.title") + " ↴"}
    </a>
    <PickedProgress pickedPercent={pickedPercent} />
  </div>
}

const isWinner = (points: PickValue, team: ChampionshipBetTeam, pickId: ChampionshipBetPick) => {
  return (!!points && points !== 0)
    ? team.id === pickId
    : pickIsSet(pickId) && team.id !== pickId
}

const EmptyTeam = () => {
  return <div className="championshipBet__pairingRow__teamBox championshipBet__pairingRow__teamBox--empty">
    ?
  </div>
}

const Round = () => {

  const {
    ranks,
    pickIndices,
    getOptions,
    pickedPercent,
    findTeam,
    currentPick,
    isCorrect,
    points,
    isOpen,
  } = useRound()

  return <div className="championshipBet__finals">
    <SectionHeader
      linkTarget="finals"
      title={I18n.t("championshipbet.finals.section_header.title")}
      infoText={I18n.t("championshipbet.finals.section_header.info_text")}
      pickedPercent={pickedPercent}
      points={points}
    />
    {map(ranks, (index) => {
      return (
        <RankingRow
          key={`rankingRow_${index}`}
          index={index}
          team={findTeam(index)}
          currentPick={currentPick(index)}
          pickIndices={pickIndices}
          options={getOptions(index)}
          isCorrect={isCorrect(index)}
          isOpen={isOpen}
        />
      )
    })}
  </div>
}

const Teaser = () => {
  return (
    <div className="championshipBet__teaser">
      {I18n.t("championshipbet.teaser.text")}
    </div>
  )
}

const _ChampionshipBet = () => {
  const { bet: { shadow, event_state, picks } } = useChampionshipBet()
  const { openTutorial } = useTutorialPopup()

  useEffect(() => {
    if (!shadow && event_state === "open" && every(picks, (pick) => !pickIsSet(pick))) {
      openTutorial()
    }
  }, [])

  return <WithPicker>
    <div className={"championshipBet" + (shadow ? " championshipBet--shadow" : "")}>
      {shadow && <Teaser />}
      <Overview />
      <Round />
    </div>
  </WithPicker>
}

const ChampionshipBet: React.FC<{authToken: string, bet: TChampionshipBet}> = ({ authToken, bet }) => {
  return <WithChampionshipBet authToken={authToken} initialBet={bet}>
    <WithTutorialPopup>
      <_ChampionshipBet />
    </WithTutorialPopup>
  </WithChampionshipBet>
}

export default ChampionshipBet
